var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import NavDropdownItem from './nav-dropdown-item';
import styled from 'styled-components';
var StyledNavItem = styled(NavDropdownItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 0;\n  padding: 0.5em 1em;\n  white-space: nowrap;\n  color: ", ";\n  &.active {\n    box-shadow: none;\n    background-color: ", ";\n    color: ", ";\n    border-left: 3px solid\n      ", ";\n  }\n"], ["\n  border-radius: 0;\n  padding: 0.5em 1em;\n  white-space: nowrap;\n  color: ", ";\n  &.active {\n    box-shadow: none;\n    background-color: ", ";\n    color: ", ";\n    border-left: 3px solid\n      ", ";\n  }\n"])), function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textPrimary : p.theme.textPrimary;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level3 : p.theme.level1;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textPrimary : p.theme.textPrimary;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.primaryB : 'inherit';
});

var DropdownNavItem = function DropdownNavItem(_a) {
  var children = _a.children,
      to = _a.to,
      props = __rest(_a, ["children", "to"]);

  return React.createElement(StyledNavItem, Object.assign({
    className: "dropdown-nav-item",
    to: to
  }, props), children);
};

export default DropdownNavItem;
var templateObject_1;